import { Info, ShieldCheck } from "lucide-react";
import { Link as RouterLink } from "react-router-dom";

export function Disclaimer({ children, testid, className = "" }) {
  return (
    <p data-testid={testid} className={`flex items-start gap-1.5 text-sm text-[#475467] ${className}`}>
      <Info size={14} className="mt-0.5 shrink-0 text-[#98A2B3]" />
      <span>{children}</span>
    </p>
  );
}

export const B9_DISCLAIMER = "B9Concept is a non-medicinal wellness protocol based on bio-energetic and trauma-resolution principles. It is not a licensed medical practice, does not replace conventional medical treatment, and is not FDA/AYUSH-approved for the treatment of any disease. Results described are based on self-reported outcomes and individual experiences may vary. Patients with acute, life-threatening, or emergency medical conditions should seek immediate conventional medical care. SarvaSeva lists B9Concept as an alternative wellness service and does not guarantee specific health outcomes. Always consult a qualified healthcare professional before modifying any treatment plan.";

export function B9Disclaimer({ testid = "b9-disclaimer", className = "" }) {
  return (
    <div data-testid={testid} className={`rounded-xl border border-[#D97706]/30 bg-[#FFFBEB] p-4 ${className}`}>
      <div className="flex items-center gap-1.5 text-[#B45309] font-semibold text-sm mb-1">
        <ShieldCheck size={15} /> B9Concept Wellness Disclaimer
      </div>
      <p className="text-xs text-[#92400E] leading-relaxed">{B9_DISCLAIMER}</p>
    </div>
  );
}

export function SiteFooter() {
  return (
    <footer className="bg-[#0D2A34] text-white/70 mt-0" data-testid="site-footer">
      <div className="h-1 w-full" data-testid="footer-tricolor-bar"
        style={{ background: "linear-gradient(to right, #FF9933 33%, #FFFFFF 33% 66%, #138808 66%)" }} />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 space-y-3">
        <Disclaimer testid="footer-medical-disclaimer" className="text-white/60">
          SarvaSeva is a technology platform that connects patients with independent healthcare providers. We are not a hospital, clinic, or medical practice. Content on this platform is for informational purposes only and does not constitute medical advice, diagnosis, or treatment. Always consult a qualified healthcare professional before making medical decisions.
        </Disclaimer>
        <Disclaimer testid="footer-platform-disclaimer" className="text-white/60">
          SarvaSeva acts as an intermediary technology platform connecting patients with independent healthcare providers. We do not guarantee medical outcomes, provider availability, treatment results, or specific savings. All medical decisions are between the patient and their chosen provider. By using this platform, you acknowledge that medical procedures carry inherent risks.
        </Disclaimer>
        <div className="flex flex-wrap items-center justify-between gap-3 pt-3 border-t border-white/10 text-xs">
          <span className="font-heading font-bold text-white/90">© {new Date().getFullYear()} SarvaSeva — सर्व सेवा — Complete Service, From Consultation to Recovery</span>
          <span className="flex items-center gap-4">
            <RouterLink to="/privacy" className="hover:text-white underline" data-testid="footer-privacy-link">Privacy Policy</RouterLink>
            <RouterLink to="/terms" className="hover:text-white underline" data-testid="footer-terms-link">Terms of Service</RouterLink>
          </span>
        </div>
      </div>
    </footer>
  );
}
